var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceDummy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 25.6V42.4C43 42.7314 42.7314 43 42.4 43H25.6C25.2686 43 25 42.7314 25 42.4V25.6C25 25.2686 25.2686 25 25.6 25H42.4C42.7314 25 43 25.2686 43 25.6Z",
    stroke: "#6C6F74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38L32 35L43 40",
    stroke: "#6C6F74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32C36.8954 32 36 31.1046 36 30C36 28.8954 36.8954 28 38 28C39.1046 28 40 28.8954 40 30C40 31.1046 39.1046 32 38 32Z",
    stroke: "#6C6F74",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    stroke: "#D2D2E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceDummy);
export default __webpack_public_path__ + "static/media/workspaceDummy.f371b45ac78822af199605c673c42a48.svg";
export { ForwardRef as ReactComponent };